export { type HarnessScope } from '@apps/web/features/phoebe_chat_v3/model/event_types';
export {
    type AgentProfile,
    type AgentProfileResolver,
} from '@apps/web/features/phoebe_chat_v3/profiles/agent_profile';
export {
    V3_PHOEBE_PROFILE_ID,
    V3_PHOEBE_RENDERER_VERSION,
    v3AgentProfileResolver,
    v3PhoebeAgentProfile,
} from '@apps/web/features/phoebe_chat_v3/profiles/v3_phoebe_profile';
export {
    type V3ChatAttachment,
    V3ChatAttachmentCard,
    type V3PresentationContext,
} from '@apps/web/features/phoebe_chat_v3/ui/chat_attachment_card';
export {
    ChatHarness,
    type ChatHarnessProps,
} from '@apps/web/features/phoebe_chat_v3/ui/chat_harness';
export {
    MessageDebugContext,
    type OpenMessageDebug,
} from '@apps/web/features/phoebe_chat_v3/ui/message_debug_context';
export { ChatOverflowMenu } from '@apps/web/features/phoebe_chat_v3/ui/primitives/chat_header';
export {
    V3RunSurface,
    type V3RunSurfaceProps,
} from '@apps/web/features/phoebe_chat_v3/ui/v3_run_surface';
